import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import RecommenderPage from "./pages/RecommenderPage/RecommenderPage";
import MentorPal from "./pages/Mentorpal/MentorPal";
import Transition from "./pages/Transition/Transition";
import { ContentPage } from "./pages/ContentPage/ContentPage";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { sendEvent, sendUserLoginEvent, sessionStartEventBuilder } from "./utils/event-helpers";
import { useWithSessionData } from "./hooks/use-with-session-data";
import { RouteTracker } from "./hooks/use-with-route-logging";
import { useWithLtikSession } from "./hooks/use-with-ltik-session";
import { RedirectControlSurvey } from "./pages/RedirectControlSurvey";
import { FinishedControlSurvey } from "./pages/FinishedControlSurvey";

export const REDIRECT_CONTROL_SURVEY_ROUTE = "/redirect-control-survey";
export const COMPLETED_CONTROL_SURVEY_ROUTE = "/completed-control-survey";

function App() {
  const { userId, userIdLoaded, sessionId, sessionIdLoaded, startNewSession } = useWithSessionData();
  const {gradePosted, submittingGrade, completedPostSurvey, completedPreSurvey, isLtikSession, canvasId} = useWithLtikSession();
  useEffect(() => {
    if(!userIdLoaded) return;
    const user = userId || startNewSession();
    sendUserLoginEvent(user);
  }, [userIdLoaded, userId, sessionId, startNewSession]);

  useEffect(() => {
    if(!sessionIdLoaded) return;
    let sessionid = sessionId;
    if (!sessionid) {
      sessionid = startNewSession();
      const userEvent = sessionStartEventBuilder(userId, sessionid);
      sendEvent(userEvent);
    }
  }, [sessionIdLoaded, userId, sessionId, startNewSession]);

  return (
    <Provider store={store}>
      <Router>
        <RouteTracker />
        <Routes>
          {/* Protected Routes */}
          <Route path="/" element={<ContentPage completedPreSurvey={completedPreSurvey} isLtikSession={isLtikSession} />} />
          <Route path="/mentorpal" element={<MentorPal completedPostSurvey={completedPostSurvey} />} />
          <Route path="/transition" element={<Transition />} /> 
          <Route path="/recommenderpage/*" element={<RecommenderPage gradePosted={gradePosted} submittingGrade={submittingGrade} completedPostSurvey={completedPostSurvey} />} />
          <Route path={REDIRECT_CONTROL_SURVEY_ROUTE} element={<RedirectControlSurvey isLtikSession={isLtikSession} canvasId={canvasId} />} />
          <Route path={COMPLETED_CONTROL_SURVEY_ROUTE} element={<FinishedControlSurvey submittingGrade={submittingGrade} gradePosted={gradePosted} />} />

        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
